import React, { useEffect, useState } from 'react'
import '../assets/css/home.css'
import '../assets/css/style.css'

import LatestRecipes from '../components/LatestRecipes'
import Categories from '../components/Categories'
import RecipesShort from '../components/RecipesShort'
import RecipesBig from '../components/RecipesBig'
import Header from '../components/Header'
import Header2 from '../components/Header2'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'


export default function Home() {
    
    const [header1, setHeader1] = useState(null);
    const [latestRecipe, setLatestRecipe] = useState([]);
    const [recipeShort, setRecipeShort] = useState([]);
    const [recipeBig, setRecipeBig] = useState([]);

    useEffect(() => {
        fetch('https://lazy-chef-api.vercel.app/home')
        .then(res => res.json())
        .then(data => {
            const h1 = data.splice(0,5);
            const latest1 = data.splice(0,2);
            const recipeShort1 = data.splice(0,6);
            const recipeBig1 = data.splice(0,3);
            setHeader1(h1);
            setLatestRecipe(latest1);
            setRecipeShort(recipeShort1);
            setRecipeBig(recipeBig1);
        })
        .catch(err => console.log(err));
      }, [])

  return (
    <div className='HomeBody'>
        <Navbar active='home'/>
    {header1 !== null ? <Header data={header1} /> : null}
    <div className='givingSomePadding'>
      <div className='container marginLeft'>
        <div className='row'>
            <div  className='col-xl-5 col-lg-12'>
                <LatestRecipes data={latestRecipe}/>
                <div className='row givingPadding'>
                        <Categories/>
                        <div className='row pt-0'>
                            <div className='col-12 dancingFont'>Start using your kitchen</div>
                        </div>
                        <div className='row'>
                            <RecipesShort data={recipeShort}/>
                        </div>
                    
                </div>
            </div>
            <div className='col-xl-7 col-lg-12 pt-lg-5 pt-sm-5'>
                <div className='rightHandSide'>
                   <RecipesBig data={recipeBig}/>
                </div>
            </div>
        </div>
      </div>
    </div>
    <Header2/>
    <Footer/>
    </div>
  )
}

